import React, { useEffect, useRef } from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children, onConfirm, invoiceId }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      modalRef.current?.focus();
      document.body.style.overflow = 'hidden';
      
      const handleEsc = (e) => {
        if (e.key === 'Escape') onClose();
      };
      window.addEventListener('keydown', handleEsc);
      
      return () => {
        window.removeEventListener('keydown', handleEsc);
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal-content" 
        ref={modalRef}
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="modal-title">{title}</h2>
        <div className="modal-body">
          {invoiceId ? (
            <>
              <p>Are you sure you want to delete invoice <strong>#{invoiceId}</strong>?</p>
              <p>This action cannot be undone.</p>
            </>
          ) : (
            children
          )}
        </div>
        <div className="modal-actions">
          <button className="btn-secondary-modal" onClick={onClose}>Cancel</button>
          {onConfirm && (
            <button className="btn-danger-modal" onClick={onConfirm}>Delete</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;